import { Component, computed, inject, output } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterModule } from '@angular/router';

import { LogoComponent } from '@components2/ui-elements/logo/logo.component';
import { NavigationItem } from '@interfaces/app/content.interfaces';
import { AvatarModule } from 'primeng/avatar';
import { ButtonModule } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { Paths } from 'src/app/app.routes';

import { ContentService } from '@services/content.service';
import { UserService } from '@services/user.service';

import { ShellService } from '../shell.service';
import { SidebarMenuComponent } from './sidebar-menu/sidebar-menu.component';
import { UserCardComponent } from './user-card/user-card.component';

@Component({
  selector: 'bk-sidebar',
  imports: [
    DrawerModule,
    ButtonModule,
    AvatarModule,
    RouterModule,
    SidebarMenuComponent,
    UserCardComponent,
    LogoComponent,
  ],
  templateUrl: './sidebar.component.html',
  styleUrl: './sidebar.component.scss',
})
export class SidebarComponent {
  closeCallback = output();
  navCallback = output();

  shellService = inject(ShellService);
  userService = inject(UserService);
  texts = inject(ContentService).texts;

  navItems = toSignal(this.shellService.navItems$);
  customerId = toSignal(this.shellService.customerId$);
  isAdmin = toSignal(this.userService.isAdmin$);

  settings = computed<NavigationItem[]>(() => {
    const settingsItems: NavigationItem[] = [
      {
        id: 'theme',
        name: this.texts.common.theme,
        icon: 'light_mode',
        routerLink: [''],
        permission: '',
        path: '',
        type: 'theme',
      },
      {
        id: 'logout',
        name: this.texts.common.logOutButton,
        icon: 'lock',
        routerLink: ['/logout'],
        permission: '',
        path: Paths.logout,
      },
    ];

    const customerId = this.customerId();
    const isAdmin = this.isAdmin();

    if (customerId) {
      settingsItems.unshift(
        {
          name: this.texts.profile.pageHeader,
          routerLink: ['/profile', customerId],
          icon: `person`,
          id: `profile`,
          path: Paths.profile,
          permission: `read.user`,
        },

        {
          id: 'switch-account',
          name: this.texts.common.switchAccountHeader,
          icon: 'apartment',
          routerLink: [''],
          permission: '',
          path: '',
          type: 'account',
        },
      );
    }

    if (customerId && isAdmin) {
      settingsItems.unshift({
        id: 'user-admin',
        name: this.texts.common.userAdminButton,
        icon: 'people',
        routerLink: ['/user-admin', customerId],
        permission: 'admin',
        path: 'user-admin',
      });
    }
    return settingsItems;
  });
}
